import { Record, Map, OrderedMap } from "immutable";

export class StatementRecord extends Record({
    id: null,
    is_active: true,
    txn_month_year: "0",
    no_of_txns: "0",
    balance: {
        balance_5th: {
            value: "0",
            is_active: false
        },
        balance_10th: {
            value: "0",
            is_active: false
        },
        balance_15th: {
            value: "0",
            is_active: false
        },
        balance_20th: {
            value: "0",
            is_active: false
        },
        balance_25th: {
            value: "0",
            is_active: false
        },
        balance_30th: {
            value: "0",
            is_active: false
        }
    },
    average_balance: "0",
    min_balance: "0",
    max_balance: "0",
    total_inward_cheque: "0",
    total_inward_cheque_bounce: "0",
    total_outward_cheque: "0",
    total_outward_cheque_bounce: "0",
    total_cheque: "0",
    total_cheque_bounce: "0",
    total_credit_amount: "0",
    total_debit_amount: "0",
    top_5_creditors_amount: "0",
    top_5_debitors_amount: "0",
    created_by: null,
    modified_by: null,
    case: null,
    case_bank_account: null
}) {
    get total_balance() {
        return this.balance
            ? new Map(this.balance)
                .filter(val => val.is_active)
                .reduce((agg, cur) => agg + +cur.value || 0, 0)
            : 0;
    }

    get key_size() {
        return this.balance
            ? new Map(this.balance).filter(val => val.is_active).size
            : 1;
    }

    get cols() {
        return OrderedMap({
            txn_month_year: {
                title: "Months",
                editable: false,
                dataIndex: "txn_month_year",
                key: "txn_month_year",
                hide: false,
                render: _ => (_ ? _.format("MMM-YYYY") : _),
                width: 100
            },
            ...new Map(this.balance)
                .map((_, k) => ({
                    hide: !_.is_active,
                    title: k,
                    dataIndex: k,
                    key: k,
                    editable: true
                }))
                .toJS(),
            total_inward_cheque: {
                title: "No of Inward Cheques",
                key: "total_inward_cheque",
                dataIndex: "total_inward_cheque",
                editable: true,
                hide: false
            },
            total_outward_cheque: {
                title: "No of Outward Cheques",
                key: "total_outward_cheque",
                dataIndex: "total_outward_cheque",
                editable: true,
                hide: false
            },
            total_inward_cheque_bounce: {
                title: "Inward Cheque Bounce",
                key: "total_inward_cheque_bounce",
                dataIndex: "total_inward_cheque_bounce",
                editable: true,
                hide: false
            },
            total_outward_cheque_bounce: {
                title: "Outward Cheque Bounce",
                key: "total_outward_cheque_bounce",
                dataIndex: "total_outward_cheque_bounce",
                editable: true,
                hide: false
            }
        });
    }
}
